<section
  id="mon-compte"
  aria-labelledby="account-title"
  class="bg-white dark:bg-slate-800 rounded-lg shadow-sm dark:shadow-slate-900/30 border border-gray-200 dark:border-slate-700 p-6"
>
  <h2
    id="account-title"
    class="text-xl font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"
  >
    <span aria-hidden="true">👤</span> Mon compte
  </h2>

  @if (error()) {
    <p
      role="alert"
      class="mb-4 rounded-lg px-4 py-3 text-sm bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-300"
    >
      {{ error() }}
    </p>
  }

  @if (preview()?.paid) {
    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6"
    >
      <p class="text-sm text-gray-600 dark:text-gray-400">
        Besoin d'une pause ? Votre abonnement s'arrête en fin de période, vos
        données sont conservées et vous reprenez quand vous voulez.
      </p>
      <a
        routerLink="/subscription"
        [queryParams]="{ action: 'pause' }"
        class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg font-semibold whitespace-nowrap"
      >
        Mettre en pause
      </a>
    </div>
  }

  @if (!confirming()) {
    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
    >
      <p class="text-sm text-gray-600 dark:text-gray-400">
        Supprimer définitivement votre compte et toutes vos données.
      </p>
      <button
        type="button"
        (click)="startDeletion()"
        [disabled]="preview() === null"
        class="px-5 py-2.5 border border-red-300 text-red-700 dark:text-red-300 rounded-lg font-semibold whitespace-nowrap disabled:opacity-50"
      >
        Supprimer mon compte
      </button>
    </div>
  } @else {
    <div
      class="rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/20 p-4 mb-4 text-sm text-red-800 dark:text-red-300"
    >
      <p class="font-semibold mb-2">Cette action est irréversible.</p>
      <ul class="list-disc list-inside space-y-1">
        <li>
          Vos produits, ventes, événements, services, prévisions et paramètres
          sont supprimés.
        </li>
        <li>Vos factures sont conservées pendant la durée légale.</li>
        @if (preview()?.paid) {
          <li>
            Votre abonnement est résilié : il reste actif
            @if (preview()?.periodEnd) {
              jusqu'au {{ preview()?.periodEnd | date: "longDate" }},
            } @else {
              jusqu'à la fin de la période en cours,
            }
            puis s'arrête sans renouvellement.
            <strong>Aucun remboursement</strong> n'est effectué pour la période
            en cours.
          </li>
        }
      </ul>
    </div>

    <form
      [formGroup]="deleteForm"
      (ngSubmit)="confirmDeletion()"
      class="grid gap-3 sm:grid-cols-2 items-end"
    >
      <label class="text-sm">
        <span class="block mb-1 text-gray-700 dark:text-gray-300"
          >Mot de passe</span
        >
        <input
          type="password"
          autocomplete="current-password"
          formControlName="password"
          class="w-full rounded-lg border border-gray-300 dark:border-slate-600 dark:bg-slate-900 px-3 py-2"
        />
      </label>
      @if (preview()?.twoFactorRequired) {
        <label class="text-sm">
          <span class="block mb-1 text-gray-700 dark:text-gray-300"
            >Code de double authentification</span
          >
          <input
            type="text"
            autocomplete="one-time-code"
            maxlength="20"
            formControlName="code"
            class="w-full rounded-lg border border-gray-300 dark:border-slate-600 dark:bg-slate-900 px-3 py-2"
          />
        </label>
      }
      <label
        class="sm:col-span-2 flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300"
      >
        <input type="checkbox" formControlName="confirmed" class="mt-1" />
        <span>
          Je comprends que mon compte et mes données seront supprimés
          définitivement.
        </span>
      </label>
      <div class="sm:col-span-2 flex gap-3">
        <button
          type="submit"
          [disabled]="deleteForm.invalid || busy()"
          class="px-5 py-2.5 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 disabled:opacity-50"
        >
          Supprimer définitivement
        </button>
        <button
          type="button"
          (click)="cancel()"
          class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg"
        >
          Annuler
        </button>
      </div>
    </form>
  }
</section>
